import { render, staticRenderFns } from "./PendingRepRegistrationList.vue?vue&type=template&id=4d62cac3&"
import script from "./PendingRepRegistrationList.vue?vue&type=script&lang=js&"
export * from "./PendingRepRegistrationList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pending-details.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports